<template>
    <div>
        <v-list v-if="items.length" two-line class="elevation-1 pa-0">
            <v-list-tile
                    v-for="(item, index) in items"
                    :key="index"
                    avatar
                    @click=""
            >
                <v-list-tile-avatar>
                    <v-icon>fas fa-user</v-icon>
                </v-list-tile-avatar>

                <v-list-tile-content>
                    <v-list-tile-title>{{ item.name }}</v-list-tile-title>
                    <v-list-tile-sub-title>{{ (item.phone ? item.areaCode + " " + item.phone : "") }}</v-list-tile-sub-title>
                </v-list-tile-content>

            </v-list-tile>
        </v-list>
        <v-alert
                v-else
                :value="true"
                color="info"
                icon="info"
                outline
        >
            {{$t('registration.no_attendee_input')}}
        </v-alert>
    </div>

</template>

<script>
    export default {
        name: "AttendeeListView",
        props: {
            items: Array
        }
    }
</script>

<style scoped>

</style>